











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'TypeDialog',
})
export default class extends Vue {
  @Prop({ required: true }) private items!: object[];

  @Prop({ required: true }) private value!: string[];

  @Prop({ required: true }) private itemKey!: string;

  @Prop({ required: true }) private itemValue!: string;

  @Prop({ required: true }) private itemTitle!: string;

  @Prop({ default: () => '' }) private itemSubTitle!: string;

  @Prop({ required: true }) private typeName!: string;

  @Prop({ default: () => false }) private disabled!: boolean;

  @Prop({ default: () => '' }) private buttonText!: string;

  @Prop({ default: () => '' }) private buttonClass!: string;

  @Prop({ default: () => true }) private buttonBlock!: boolean;

  @Prop({ default: () => '' }) private buttonColor!: string;

  private dialog = false;

  private selectValue: string[] = [];

  @Watch('value')
  onChangeValue(newVal: string[]) {
    this.selectValue = newVal;
  }

  created() {
    this.selectValue = this.value;
  }

  private save() {
    this.$emit('input', this.selectValue);
    this.$emit('save');
    this.dialog = false;
  }

  private close() {
    this.selectValue = this.value;
    this.dialog = false;
  }

  get genbuttonText() {
    if (this.buttonText !== '') {
      return this.buttonText;
    }
    if (this.selectValue.length === this.items.length && this.selectValue.length !== 0) {
      return `${this.typeName}: All`;
    }
    const data = this.selectValue.slice().sort((n1, n2) => {
      n1.toLowerCase();
      n2.toLowerCase();
      if (n1 < n2) return -1;
      if (n1 > n2) return 1;
      return 0;
    });
    return `${this.typeName}: ${data.join(',')}`;
  }
}
